import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/ToastProvider/ToastProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import LoginPage from './pages/LoginPages/LoginPage';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import LandingPage from './pages/LandingPage/LandingPage';
import AdminPortalPage  from './pages/AdminPortalPage/AdminPortalPage';
import CategoryManagementPage from './pages/CategoryManagementPage/CategoryManagementPage';
import ManufacturerManagementPage from './pages/ManufacturerManagementPage/ManufacturerManagementPage';
import UserPortalPage from './pages/UserPortalPage/UserPortalPage';
import ProductsLandingPage from './pages/ProductLandingPage/ProductLandingPage';
import OrderManagement from './pages/OrderManagment/OrderManagement';
import UploadProductPage from './pages/UploadProductPage/UploadProductPage';
import OrderManagementTabs from './components/OrderManagementTabs/OrderManagementTabs';
import OrderStatusFinal from './pages/OrderStatusFinal/OrderStatusFinal';
import ResetPassword from './pages/ResetPasswordPage/ResetPasswordPage';
import RegisterPage from './pages/RegisterPage/RegisterPage';
import ProceedToPreorderPage from './pages/ProceedToPreorderPage/ProceedToPreorderPage';
import UserOrderManagement from './pages/UserOrderManagement/UserOrderManagement'
import UserProfilePage from './pages/UserProfileInfoPage/UserProfileInfoPage';
import ManageBusinessUsersPage from './pages/ManageBusinessUsersPage/ManageBusinessUsersPage';
import PaymentReturnPage from './pages/PaymentReturnPage/PaymentReturnPage';
import UserManagementPage from './pages/UserManagementPage/UserManagementPage';
import CustomerManagementPage from './pages/CustomerManagementPage/CustomerManagementPage';
import CustomerDetailPage from './pages/CustomerManagementPage/CustomerDetailPage';
import RoleManagementPage from './pages/RoleManagementPage/RoleManagementPage';
import VendorManagementPage from './pages/VendorManagementPage/VendorManagementPage';
import PaymentRequestPage from './pages/PaymentRequestPage/PaymentRequestPage';
import PaymentRequestPayPage from './pages/PaymentRequestPayPage/PaymentRequestPayPage';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const defaultTheme = createTheme();

function App() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <ToastProvider>
        <CssBaseline />
        <AuthProvider>
          <Router>
            <Routes>
              {/* Public routes */}
              <Route path="/landing" element={<LandingPage />} />
              <Route path="/landing/products" element={<ProductsLandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/pay/:token" element={<PaymentRequestPayPage />} />
              <Route path="/proceed-to-preorder" element={<ProceedToPreorderPage />} />

              {/* Customer routes (auth required) */}
              <Route path="/user-portal" element={<ProtectedRoute><UserPortalPage /></ProtectedRoute>} />
              <Route path="/user-order-management/:orderId" element={<ProtectedRoute><UserOrderManagement /></ProtectedRoute>} />
              <Route path="/user-profile" element={<ProtectedRoute><UserProfilePage /></ProtectedRoute>} />
              <Route path="/user-business-users" element={<ProtectedRoute><ManageBusinessUsersPage /></ProtectedRoute>} />
              <Route path="/payment-return" element={<ProtectedRoute><PaymentReturnPage /></ProtectedRoute>} />

              {/* Team/Admin routes (permission gated) */}
              <Route path="/product-management" element={<ProtectedRoute permissions={["products.manage"]}><AdminPortalPage /></ProtectedRoute>} />
              <Route path="/upload-product" element={<ProtectedRoute permissions={["products.manage"]}><UploadProductPage /></ProtectedRoute>} />
              <Route path="/category-management" element={<ProtectedRoute permissions={["categories.manage"]}><CategoryManagementPage /></ProtectedRoute>} />
              <Route path="/mfr-management" element={<ProtectedRoute permissions={["manufacturers.manage"]}><ManufacturerManagementPage /></ProtectedRoute>} />

              <Route path="/order-management" element={<ProtectedRoute permissions={["orders.manage", "orders.view"]}><OrderManagement /></ProtectedRoute>} />
              <Route path="/orders/:orderNumber" element={<ProtectedRoute permissions={["orders.manage", "orders.view"]}><OrderManagementTabs /></ProtectedRoute>} />
              <Route path="/order-status-final" element={<ProtectedRoute permissions={["orders.manage"]}><OrderStatusFinal /></ProtectedRoute>} />

              <Route path="/payment-requests" element={<ProtectedRoute permissions={["payments.manage", "payments.verify"]}><PaymentRequestPage /></ProtectedRoute>} />
              <Route path="/customer-management" element={<ProtectedRoute permissions={["customers.manage", "customers.view"]}><CustomerManagementPage /></ProtectedRoute>} />
              <Route path="/customer-management/:userId" element={<ProtectedRoute permissions={["customers.manage", "customers.view"]}><CustomerDetailPage /></ProtectedRoute>} />
              <Route path="/user-management" element={<ProtectedRoute permissions={["users.manage"]}><UserManagementPage /></ProtectedRoute>} />
              <Route path="/role-management" element={<ProtectedRoute permissions={["roles.manage"]}><RoleManagementPage /></ProtectedRoute>} />
              <Route path="/vendor-management" element={<ProtectedRoute permissions={["vendors.manage"]}><VendorManagementPage /></ProtectedRoute>} />

              <Route path="*" element={<Navigate to="/landing" replace />} />
            </Routes>
          </Router>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
